import { Flex, TextProps } from '@chakra-ui/react'

export interface CardMessageProps extends TextProps {
  message?: string
}

export const CardMessage = ({ message }: CardMessageProps) => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100%"
      fontSize="14px"
      color="presets.neutral.80"
      fontWeight="500"
    >
      {message}
    </Flex>
  )
}
